export const URL_FUNCION =
  "/Seguridad/WebService/SeguridadWebService.asmx/BuscarFuncionesPorPerfil";
export const URL_ACTUALIZAR_FUNCIONES =
  "/Seguridad/WebService/SeguridadWebService.asmx/ActualizarFuncionesPerfil";
export const URL_OBTENER_PERFILES =
  "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerPerfilesAImportar";
export const URL_IMPORTAR_PERFIL =
  "/Seguridad/WebService/SeguridadWebService.asmx/ImportarPerfil";
export const URL_OBTENER_USUARIO_LOGIN =
    "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerUsuarioLogin";
export const URL_OBTENER_COMPANIA =
    "/Seguridad/WebService/SeguridadWebService.asmx/ObtenerCompania";
export const URL_ACTUALIZAR_INFORMACION_COMPANIA =
    "/Seguridad/WebService/SeguridadWebService.asmx/ActualizarInformacionCompania";

// Asistente interno de documentacion (CitrusGPT).
export const URL_CITRUSGPT_INICIAR_CHAT =
    "/Seguridad/WebService/AsistenteWebService.asmx/IniciarChat";
export const URL_CITRUSGPT_ABRIR_CHAT =
    "/Seguridad/WebService/AsistenteWebService.asmx/AbrirChat";
export const URL_CITRUSGPT_NUEVA_CONVERSACION =
    "/Seguridad/WebService/AsistenteWebService.asmx/NuevaConversacion";
export const URL_CITRUSGPT_PREGUNTAR =
    "/Seguridad/WebService/AsistenteWebService.asmx/Preguntar";
export const URL_CITRUSGPT_BUSCAR_CONVERSACIONES =
    "/Seguridad/WebService/AsistenteWebService.asmx/BuscarConversaciones";

// Revision del conocimiento del asistente.
export const URL_CONOCIMIENTO_IA_INICIAR_REVISION =
    "/Seguridad/WebService/AsistenteWebService.asmx/IniciarRevision";
export const URL_CONOCIMIENTO_IA_REGISTRAR_VEREDICTO =
    "/Seguridad/WebService/AsistenteWebService.asmx/RegistrarVeredicto";
export const URL_CONOCIMIENTO_IA_GUARDAR_CORRECCIONES =
    "/Seguridad/WebService/AsistenteWebService.asmx/GuardarCorreccionesDocumentacion";
export const URL_CONOCIMIENTO_IA_MARCAR_APLICADAS =
    "/Seguridad/WebService/AsistenteWebService.asmx/MarcarCorreccionesAplicadas";
export const URL_CONOCIMIENTO_IA_BUSCAR_AMPLIACION =
    "/Seguridad/WebService/AsistenteWebService.asmx/BuscarAmpliacion";
export const URL_CONOCIMIENTO_IA_AMPLIAR =
    "/Seguridad/WebService/AsistenteWebService.asmx/AmpliarConocimiento";

export const RUTA_CITRUSGPT = "/App/Seguridad/Asistente";
export const RUTA_CONOCIMIENTO_IA_EDIT = "/App/Seguridad/ConocimientoIAEdit";
export const URL_CONOCIMIENTO_IA_LIST = "/Seguridad/conocimiento_ia_list.aspx";
    

